import { render, staticRenderFns } from "./AlertsRoot.vue?vue&type=template&id=0010fff8"
import script from "./AlertsRoot.vue?vue&type=script&lang=ts"
export * from "./AlertsRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports